module.exports = __webpack_public_path__ + "img/1.30fe8765.png";